import { request, orgBase } from '@/api/http'

export interface OrgComplianceConfig {
  organization_id?: string
  standards: string[]
  region?: string
  updated_at?: string
}

export const orgComplianceApi = {
  // Org-level default compliance standards (framework alias keys).
  get(orgId: string): Promise<OrgComplianceConfig> {
    return request(`${orgBase(orgId)}/compliance/standards`)
  },
  set(orgId: string, standards: string[], region?: string): Promise<OrgComplianceConfig> {
    return request(`${orgBase(orgId)}/compliance/standards`, {
      method: 'PUT',
      body: JSON.stringify({ standards, region }),
    })
  },
}
